import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";
import { useNavigate } from "react-router-dom"; // Import the useNavigate hook
import logo2 from "./logo2.png";
import "./Reports.css";

const Reports = () => {
  const [tasks, setTasks] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "tasks"),
      (snapshot) => {
        const tasksData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setTasks(tasksData);
      },
      (err) => {
        setError("Error fetching task reports. Please try again later.");
        console.error("Error fetching reports:", err);
      }
    );

    return () => unsubscribe();
  }, []);

  // Helper function to calculate status durations
  const calculateDuration = (start, end) => {
    if (!start || !end) return "N/A";
    const startTime = new Date(start.toDate());
    const endTime = new Date(end.toDate());
    const durationMs = endTime - startTime;

    const hours = Math.floor(durationMs / (1000 * 60 * 60));
    const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}h ${minutes}m`;
  };

  const handleNavigateToTaskList = () => {
    navigate("/tasklist"); // Navigate to Task List page
  };

  return (
    <div className="reports-container">
      <img src={logo2} alt="Logo 2" className="task-logo" />
      <div className="task-header">
        <h1>Task Reports</h1>
        <button onClick={handleNavigateToTaskList} className="navigate-button">
          Back to Task List
        </button>
        {error && <p className="error-message">{error}</p>}
      </div>
      <table className="reports-table">
        <thead>
          <tr>
            <th>Task</th>
            <th>Assignee</th>
            <th>Patient/Room</th>
            <th>Status History</th>
            <th>Status Durations</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((task) => {
            const statusHistory = task.statusHistory || [];
            const timestamps = task.statusTimestamps || {};
            const durations = {
              Pending: calculateDuration(timestamps.pendingAt, timestamps.inProgressAt),
              "In Progress": calculateDuration(timestamps.inProgressAt, timestamps.onHoldAt),
              "On Hold": calculateDuration(timestamps.onHoldAt, timestamps.completedAt),
            };

            return (
              <tr key={task.id}>
                <td>{task.text || "N/A"}</td>
                <td>{task.assignee || "Unassigned"}</td>
                <td>{task.patientRoom || "N/A"}</td>
                <td>
                  <ul>
                    {statusHistory.map((entry, index) => (
                      <li key={index}>
                        <strong>{entry.status}</strong> by {entry.updatedBy} at{" "}
                        {new Date(entry.timestamp).toLocaleString()}
                      </li>
                    ))}
                  </ul>
                </td>
                <td>
                  <ul>
                    {Object.keys(durations).map((status) => (
                      <li key={status}>
                        {status}: {durations[status]}
                      </li>
                    ))}
                  </ul>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Reports;
